import { take, put, all, select, takeEvery } from 'redux-saga/effects';


import {
  setSurroundingId,
} from './actions';



export default function* surroundingRoot() {
  yield all([]);
}



// WEBPACK FOOTER //
// ./src/redux/surrounding/sagas.js